<mat-form-field>
	<mat-label>{{ placeholder }}</mat-label>
	<span matPrefix class="selectAll" (click)="selectAll()" *ngIf="opened">
		<i class="far fa-check-square"></i>
	</span>
	<mat-chip-grid #chipList [disabled]="disabled">
		<mat-chip-row *ngFor="let item of selected" (removed)="remove(item)" (click)="onClick(item)">
			{{ item[labelKey] }}
			<button matChipRemove>
				<i class="fas fa-times"></i>
			</button>
		</mat-chip-row>
		<input
			placeholder="Szukaj..."
			#optionsInput
			[matChipInputFor]="chipList"
			[matAutocomplete]="autoCompleteInput"
			(keyup)="filter()"
		/>
	</mat-chip-grid>
	<span matSuffix class="clear" (click)="clear()" *ngIf="!disabled">
		<i class="fas fa-times"></i>
	</span>
	<mat-autocomplete
		#autoCompleteInput="matAutocomplete"
		(opened)="autocompleteToggle(true)"
		(closed)="autocompleteToggle(false)"
	>
		<mat-option *ngFor="let item of optionsFiltered" [value]="selected">
			<div (click)="optionClicked($event, item)">
				<mat-checkbox
					[checked]="selected.includes(item)"
					(change)="toggleSelection(item)"
					(click)="$event.stopPropagation()"
					color="primary"
				>
					{{ item[labelKey] }}
				</mat-checkbox>
			</div>
		</mat-option>
	</mat-autocomplete>
</mat-form-field>
